import { Table, Button, Space, Card, Skeleton, Tooltip, Row, Col, Popconfirm, Switch, Tag } from 'antd';
import { licensedata } from '../typing/table_typing';
import { Component } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from '../../../intl-compat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { compareText, compareVersion } from '../../UpdateContainer/view/update_columns';
import { foreignKeyDetail, isArchived, mayRemove, mayRestore, removableSelection, showsUnused } from '../typing/licence_rows';



export interface TableThingyMainProps{
  TargetTable_data:{
    license:licensedata[],
  }
  view:
  {
    loaded: boolean,
    autorefresh: boolean,
  }
  isAdmin: boolean,
  onLoadRequested:(includeArchived:boolean)=>void;
  onRemove:(uuid:string, includeArchived:boolean, inUseText:string)=>void;
  onRemoveSeveral:(uuids:string[], includeArchived:boolean,
                   texts:{ summary:(archived:number, unchanged:number, refused:number) => string, failed:string })=>void;
  onRestore:(uuid:string, includeArchived:boolean)=>void;
}

interface TableThinyViewInnerState{filteredInfo:any, sortedInfo:any, showArchived:boolean, selected:string[]}

class TableThingyView extends Component<TableThingyMainProps& {intl:any}, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps& {intl:any}){
      super(props);
      this.state = {
        filteredInfo: null,
        sortedInfo: null,
        showArchived: false,
        selected: [],
      };
    }

    t = (id:string, values?:Record<string, any>) => this.props.intl.formatMessage({ id }, values);

    // The hub hides removed licences unless asked (anima_core #8).
    onShowArchived = (showArchived:boolean) => {
      this.setState({ showArchived, selected: [] });
      this.props.onLoadRequested(showArchived);
    };

    // Bulk removal of the selected unused licences (anima_core #7).
    onRemoveSelected = (uuids:string[]) => {
      this.setState({ selected: [] });
      this.props.onRemoveSeveral(uuids, this.state.showArchived, {
        summary: (archived, unchanged, refused) => this.t("License:RemoveSeveralDone", { archived, unchanged, refused }),
        failed: this.t("License:RemoveSeveralFailed"),
      });
    };


    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested(this.state.showArchived)
      }, 120);
      
      // this.props.onButtonClicked();
    }
   
    handleChange = (pagination:any, filters:any, sorter:any) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };
      

  

render(){
  let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    // Sorting by content, one key per column (05.10.2026): the columns
    // compared text lengths or subtracted strings, three shared the key 'b'.
    const sortOrderOf = (key:string) => (sortedInfo.columnKey === key ? sortedInfo.order : null) || null;

    const columns = [
      {
        title: <FormattedMessage id="License" defaultMessage="License" />,
        dataIndex: 'uuid',
        key: 'uuid',
        sorter: (a:any, b:any) => compareText(a.uuid, b.uuid),
        sortOrder: sortOrderOf('uuid'),
        ellipsis: false,
      },
      {
        title: <FormattedMessage id="Branch" defaultMessage="Branch" />,
        dataIndex: 'branch',
        key: 'branch',
        sorter: (a:any, b:any) => compareText(a.branch + '/' + a.edition, b.branch + '/' + b.edition),
        sortOrder: sortOrderOf('branch'),
        ellipsis: false,
        render: (type:any, b:any) => (
           <div> {b.branch}/ {b.edition}</div>
         ),
      },
      {
        title: <FormattedMessage id="client" defaultMessage="Client" />,
        dataIndex: 'licensedTo',
        key: 'licensedTo',
        sorter: (a:any, b:any) => compareText(a.licensedTo, b.licensedTo),
        sortOrder: sortOrderOf('licensedTo'),
        ellipsis: true,
        render: (type:any, b:any) => (
           <div>
            <Tooltip title={(b.comment ?? "").replace(";","")}>
            {b.licensedTo}<br/>
            <FontAwesomeIcon icon={["fas", "cart-plus"]}/>{b.created}<br/>
            </Tooltip>
            {(b.comment ?? "").replace(";","")}
           </div>
          ),
      },
      {
        title: <div><FormattedMessage id="NumberOfTargets" defaultMessage="numberOfTargets" />
                <FontAwesomeIcon icon={["fas", "network-wired"]}/>
                <FontAwesomeIcon icon={["fas", "cart-arrow-down"]}/></div>,
        dataIndex: 'numberOfTargets',
        key: 'numberOfTargets',
        sorter: (a:any, b:any) => (a.numberOfTargets ?? 0) - (b.numberOfTargets ?? 0),
        sortOrder: sortOrderOf('numberOfTargets'),
        ellipsis: false,
        render: (type:any, b:any) => (
          <div>
          
          <Row>
          <Col>{b.currentTargets}</Col>
            <Col> / </Col>
            <Col>{b.numberOfTargets}</Col>

          </Row>
          </div>
          ),
      },
      {
        title: <FormattedMessage id="Status" defaultMessage="status" />,
        dataIndex: 'status',
        key: 'status',
        sorter: (a:any, b:any) => compareText(a.status, b.status),
        sortOrder: sortOrderOf('status'),
        ellipsis: false,
        render: (type:any, b:any) => (
          <div>
          {b.status}<br/>
          <FontAwesomeIcon icon={["fas", "eye"]}/>{b.lastSeen}
          <br/>
          <FontAwesomeIcon icon={["fas", "galactic-senate"]}/>{b.expirationDate}
          </div>
          ),
      },
      {
        title: <FormattedMessage id="Version" defaultMessage="version" />,
        dataIndex: 'version',
        key: 'version',
        sorter: (a:any, b:any) => compareVersion(a.version, b.version),
        sortOrder: sortOrderOf('version'),
        ellipsis: false,
        render: (type:any, b:any) => (
          <div>
          {b.version}
          </div>
          ),
      },
      {
        title: <FormattedMessage id="Details" defaultMessage="Details" />,
        dataIndex: 'uuid',
        key: 'details',
        ellipsis: true,
        render: (type:any, b:any) => (
          <Space>
            <Button ><Link to={"/License/"+b.uuid}> Details</Link> </Button>
            {isArchived(b) && <Tag>{this.t("License:ArchivedTag")}</Tag>}
            {showsUnused(b) && (
              <Tooltip title={this.t("License:UnusedHint")}><Tag color="orange">{this.t("License:UnusedTag")}</Tag></Tooltip>
            )}
            {/* The spoke checks this licence with a key that is not the hub's (Core#6). */}
            {foreignKeyDetail(b) !== null && (
              <Tooltip title={this.t("License:ForeignKeyHint") + " " + foreignKeyDetail(b)}><Tag color="red">{this.t("License:ForeignKeyTag")}</Tag></Tooltip>
            )}
            {/* Remove = archive on the hub, admins only, unused only (anima_core #8, #7). */}
            {mayRemove(b, this.props.isAdmin) && (
              <Popconfirm
                title={this.t("License:RemoveConfirm")}
                description={this.t("License:RemoveHint")}
                okText={this.t("License:Remove")}
                cancelText={this.t("License:Cancel")}
                onConfirm={() => this.props.onRemove(b.uuid, this.state.showArchived, this.t("License:RemoveInUse"))}
              >
                <Button danger>{this.t("License:Remove")}</Button>
              </Popconfirm>
            )}
            {mayRestore(b, this.props.isAdmin) && (
              <Button onClick={() => this.props.onRestore(b.uuid, this.state.showArchived)}>{this.t("License:Restore")}</Button>
            )}
          </Space>
        ),
      },
    ];

    if (this.props.view.loaded === false)
    {
      return (
        <div>
          <Card title={<FormattedMessage id="ActiveTargetlist" defaultMessage="Active Targetlist" />} style={cardmargin}   hoverable styles={{ header: grayheader }}>
          <Skeleton active />
          </Card>
          </div>
      )    
    }
    else
    {
  const rows = this.props.TargetTable_data.license ?? [];
  const toRemove = removableSelection(rows, this.state.selected, this.props.isAdmin);
  // Only admins select, and only licences that may be removed (anima_core #7).
  const rowSelection = this.props.isAdmin ? {
    selectedRowKeys: toRemove,
    onChange: (keys:React.Key[]) => this.setState({ selected: keys.map(String) }),
    getCheckboxProps: (row:licensedata) => ({ disabled: !mayRemove(row, true) }),
  } : undefined;
  return (
    <div>
      <Card title={<FormattedMessage id="ActiveTargetlist" defaultMessage="Active Targetlist" />} style={cardmargin}   hoverable styles={{ header: grayheader }}>
    <Space style={{ marginBottom: 16 }}>
      <Switch checked={this.state.showArchived} onChange={this.onShowArchived} /> {this.t("License:ShowArchived")}
      {this.props.isAdmin && (
        <Popconfirm
          title={this.t("License:RemoveSeveralConfirm", { count: toRemove.length })}
          description={this.t("License:RemoveHint")}
          okText={this.t("License:Remove")}
          cancelText={this.t("License:Cancel")}
          disabled={toRemove.length === 0}
          onConfirm={() => this.onRemoveSelected(toRemove)}
        >
          <Button danger disabled={toRemove.length === 0}>{this.t("License:RemoveSelected", { count: toRemove.length })}</Button>
        </Popconfirm>
      )}
      {/* <Button onClick={this.setAgeSort}>Sort age</Button>
      <Button onClick={this.clearFilters}>Clear filters</Button>
      <Button onClick={this.clearAll}>Clear filters and sorters</Button> */}
    </Space>
    <Table rowKey="uuid" rowSelection={rowSelection} columns={columns} dataSource={rows} onChange={this.handleChange} />
    </Card>
    </div>
  )}
}
}

export default injectIntl(TableThingyView);